export default __webpack_public_path__ + "static/media/41_galago.a92bec6b.JPG";